module.exports = __webpack_public_path__ + "static/media/minimize.ebfb00ed.svg";